(function () {
  if (window.relodeYotpoSizeFitInitialized) {
    return;
  }

  window.relodeYotpoSizeFitInitialized = true;

  var QUESTION_SELECTOR = '.yotpo-custom-questions-range-question-wrapper';
  var TARGET_SELECTOR = '[data-yotpo-size-fit-target]';
  var VALUE_SELECTOR = '.yotpo-custom-questions-range-question-value';
  var SCORE_SELECTOR = '.yotpo-progress-bar-score';
  var YOTPO_API_BASE = 'https://api.yotpo.com/v1/widget/';

  var valuePositionFallbacks = {
    small: 0,
    liten: 0,
    perfekt: 50,
    perfect: 50,
    'true to size': 50,
    'fits true to size': 50,
    normal: 50,
    large: 100,
    stor: 100
  };

  var valueCategories = {
    small: 'small',
    liten: 'small',
    perfekt: 'perfect',
    perfect: 'perfect',
    'true to size': 'perfect',
    'fits true to size': 'perfect',
    normal: 'perfect',
    large: 'large',
    stor: 'large'
  };

  function clamp(number, min, max) {
    return Math.min(Math.max(number, min), max);
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function parsePercent(value) {
    var match = String(value || '').match(/-?\d+(\.\d+)?/);
    if (!match) {
      return null;
    }

    return clamp(parseFloat(match[0]), 0, 100);
  }

  function findSizeQuestion() {
    var questions = Array.prototype.slice.call(document.querySelectorAll(QUESTION_SELECTOR));

    return questions.find(function (question) {
      var type = normalizeText(question.getAttribute('type')).toLowerCase();
      var title = normalizeText(
        question.querySelector('.yotpo-custom-questions-range-question-title')?.textContent
      ).toLowerCase();

      return type === 'size' || title === 'size';
    });
  }

  function getLabels(target) {
    return {
      small: target.dataset.labelSmall || 'Small',
      perfect: target.dataset.labelPerfect || 'True to size',
      large: target.dataset.labelLarge || 'Large'
    };
  }

  function getDisplayValue(rawValue, labels) {
    var key = normalizeText(rawValue).toLowerCase();
    var category = valueCategories[key];

    return labels[category] || normalizeText(rawValue);
  }

  function renderTemplate(template, value) {
    return String(template || '').replace('[[value]]', value);
  }

  function getDisplayValueFromScore(score, labels) {
    if (score <= 1.05) {
      return labels.small;
    }

    if (score >= 2.95) {
      return labels.large;
    }

    if (Math.abs(score - 2) < 0.05) {
      return labels.perfect;
    }

    if (score < 2) {
      return labels.small + ' / ' + labels.perfect;
    }

    return labels.perfect + ' / ' + labels.large;
  }

  function getMarkerPositionFromScore(score) {
    return clamp(((score - 1) / 2) * 100, 0, 100);
  }

  function getYotpoSizeField(customFields) {
    if (!customFields) {
      return null;
    }

    return Object.keys(customFields).map(function (key) {
      return customFields[key];
    }).find(function (field) {
      var type = normalizeText(field && field.type).toLowerCase();
      var title = normalizeText(field && field.title).toLowerCase();

      return type === 'size' || title === 'size';
    });
  }

  function getYotpoEndpoint(target) {
    var appKey = normalizeText(target.dataset.yotpoAppKey);
    var productId = normalizeText(target.dataset.yotpoProductId);

    if (!appKey || !productId) {
      return '';
    }

    return YOTPO_API_BASE
      + encodeURIComponent(appKey)
      + '/products/'
      + encodeURIComponent(productId)
      + '/reviews.json?per_page=5&page=1&_='
      + Date.now();
  }

  function getReviewsFromData(data) {
    var reviews = data && data.response ? data.response.reviews : null;

    return Array.isArray(reviews) ? reviews : [];
  }

  function getYotpoReviewCount(data) {
    var bottomline = data && data.response ? data.response.bottomline : null;
    var pagination = data && data.response ? data.response.pagination : null;
    var bottomlineCount = Number(bottomline && (bottomline.total_review || bottomline.total_reviews || bottomline.total_organic_reviews));
    var paginationCount = Number(pagination && pagination.total);
    var reviewsCount = getReviewsFromData(data).length;

    return Math.max(
      Number.isFinite(bottomlineCount) ? bottomlineCount : 0,
      Number.isFinite(paginationCount) ? paginationCount : 0,
      reviewsCount
    );
  }

  function getYotpoSizeScoreFromReviews(reviews) {
    var values = [];

    reviews.forEach(function (review) {
      var customFields = review && review.custom_fields;

      if (!customFields) {
        return;
      }

      Object.keys(customFields).forEach(function (key) {
        var field = customFields[key];
        var title = normalizeText(field && field.title).toLowerCase();
        var type = normalizeText(field && (field.type || field.field_type)).toLowerCase();
        var value = Number(field && field.value);

        if ((title === 'size' || type === 'size') && Number.isFinite(value)) {
          values.push(clamp(value, 1, 3));
        }
      });
    });

    if (!values.length) {
      return null;
    }

    return values.reduce(function (total, value) {
      return total + value;
    }, 0) / values.length;
  }

  function fetchYotpoSizeScore(target) {
    var endpoint = getYotpoEndpoint(target);

    if (!endpoint || typeof window.fetch !== 'function') {
      return Promise.resolve(null);
    }

    return window.fetch(endpoint, { credentials: 'omit', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Yotpo request failed');
        }

        return response.json();
      })
      .then(function (data) {
        var customFields = data && data.response && data.response.bottomline
          ? data.response.bottomline.custom_fields_bottomline
          : null;
        var sizeField = getYotpoSizeField(customFields);
        var score = Number(sizeField && (sizeField.score || sizeField.average_score));

        if (!Number.isFinite(score)) {
          score = getYotpoSizeScoreFromReviews(getReviewsFromData(data));
        }

        if (!Number.isFinite(score)) {
          return {
            reviewCount: getYotpoReviewCount(data),
            score: null
          };
        }

        return {
          reviewCount: getYotpoReviewCount(data),
          score: clamp(score, 1, 3)
        };
      })
      .catch(function () {
        return null;
      });
  }

  function renderReviewCount(target, reviewCount) {
    var link = target.querySelector('[data-yotpo-size-fit-reviews-link]');
    var label = normalizeText(target.dataset.reviewLabel) || 'Reviews';

    if (!link || !Number.isFinite(reviewCount)) {
      return;
    }

    link.textContent = reviewCount + ' ' + label;
  }

  function renderTarget(target, markerPosition, displayValue, reviewCount) {
    var meter = target.querySelector('[data-yotpo-size-fit-meter]');
    var summary = target.querySelector('[data-yotpo-size-fit-summary]');
    var ariaLabel = renderTemplate(target.dataset.ariaTemplate, displayValue);
    var summaryText = renderTemplate(target.dataset.summaryTemplate, displayValue);

    target.style.setProperty('--size-fit-position', markerPosition + '%');
    target.hidden = false;

    if (meter) {
      meter.setAttribute('aria-label', ariaLabel || displayValue);
    }

    if (summary) {
      summary.textContent = summaryText;
    }

    renderReviewCount(target, reviewCount);
  }

  function renderSizeFitFromApi() {
    var targets = Array.prototype.slice.call(document.querySelectorAll(TARGET_SELECTOR));
    if (!targets.length) {
      return Promise.resolve(false);
    }

    return fetchYotpoSizeScore(targets[0]).then(function (result) {
      if (!result) {
        return false;
      }

      if (Number.isFinite(result.reviewCount)) {
        targets.forEach(function (target) {
          renderReviewCount(target, result.reviewCount);
        });
      }

      if (result.score === null) {
        return false;
      }

      var markerPosition = getMarkerPositionFromScore(result.score);

      targets.forEach(function (target) {
        renderTarget(target, markerPosition, getDisplayValueFromScore(result.score, getLabels(target)), result.reviewCount);
      });

      return true;
    });
  }

  function getMarkerPosition(question, rawValue) {
    var scoreElement = question.querySelector(SCORE_SELECTOR);
    var key = normalizeText(rawValue).toLowerCase();
    var fallback = valuePositionFallbacks[key] || 50;

    if (!scoreElement) {
      return fallback;
    }

    var width = parsePercent(scoreElement.style.width);
    var marginLeft = parsePercent(scoreElement.style.marginLeft) || 0;

    if (width === null) {
      return fallback;
    }

    return clamp(marginLeft + width, 0, 100);
  }

  function renderSizeFitFromDom() {
    var targets = Array.prototype.slice.call(document.querySelectorAll(TARGET_SELECTOR));
    if (!targets.length) {
      return false;
    }

    var sizeQuestion = findSizeQuestion();
    if (!sizeQuestion) {
      return false;
    }

    var rawValue = normalizeText(sizeQuestion.querySelector(VALUE_SELECTOR)?.textContent);
    if (!rawValue) {
      return false;
    }

    var markerPosition = getMarkerPosition(sizeQuestion, rawValue);

    targets.forEach(function (target) {
      var labels = getLabels(target);
      var displayValue = getDisplayValue(rawValue, labels);
      renderTarget(target, markerPosition, displayValue);
    });

    return true;
  }

  function scrollToReviews(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var link = event.target.closest('[data-yotpo-size-fit-reviews-link]');
    if (!link) {
      return;
    }

    var targetId = link.getAttribute('href')?.replace('#', '');
    var targetElement = targetId ? document.getElementById(targetId) : null;

    if (!targetElement) {
      return;
    }

    event.preventDefault();

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    targetElement.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + targetId);
    }
  }

  document.addEventListener('click', scrollToReviews);

  function refreshSizeFit() {
    return renderSizeFitFromApi().then(function (renderedFromApi) {
      return renderedFromApi || renderSizeFitFromDom();
    });
  }

  function startSizeFitDomObserver() {
    var observer = new MutationObserver(function () {
      if (renderSizeFitFromDom()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  refreshSizeFit().then(function (rendered) {
    if (rendered) {
      return;
    }

    startSizeFitDomObserver();
  });

  if (!window.relodeYotpoSizeFitRefreshInitialized) {
    window.relodeYotpoSizeFitRefreshInitialized = true;

    [5000, 20000, 60000].forEach(function (delay) {
      window.setTimeout(refreshSizeFit, delay);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        refreshSizeFit();
      }
    });

    window.addEventListener('pageshow', refreshSizeFit);
  }

})();
